import { onMounted } from 'vue'
import store from '@/store'

let gtmScriptAdded = false

export function useGTM() {
  const mode = process.env.VUE_APP_GTM_MODE ?? 'consent'
  const containerId = process.env.VUE_APP_GTM_CONTAINER_ID

  if (!containerId) {
    return
  }

  onMounted(() => {
    if (mode === 'consent') {

      store.watch(
        (state) => state.consent.given,
        ({ marketing, performance }) => {
          if (marketing || performance) {
            injectGtmContainer()
          }
        },
        { immediate: true },
      )

      return
    }

    injectGtmContainer()
  })

  const injectGtmContainer = () => {
    if (gtmScriptAdded) {
      return
    }
    gtmScriptAdded = true

    ;(function (w, d, s, l, i) {
      w[l] = w[l] || []
      w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      })
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : ''
      j.async = true
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
      f.parentNode.insertBefore(j, f)
    })(window, document, 'script', 'dataLayer', containerId)
  }
}
